import ErrorBoundary from "../error_boundary";
import React from "react";

const Loading = ({ loading, children }) => {
  if (loading) return <div className="text-center">Loading....</div>;

  return <ErrorBoundary>{children}</ErrorBoundary>;
}

export default Loading;